export default {
      id: "ar_portail-usage",
      viewBox: "0 0 140 100",
      url: "../dist/images/" + "sprite.svg#ar_portail-usage",
      toString: function () {
        return this.url;
      }
    }